/* Stylesheet */

.operator_container {
  display: flex;
  margin: 21px 0px 0px 0px;
  gap: 6px;
}
